import { Collapse as AntdCollapse } from 'antd';
import styled from 'styled-components';

import CommonButton from '~atoms/CommonButton';
import { Legend } from '~molecules/FilterOptions';

export const Container = styled.section(({ theme }) => ({
  boxSizing: 'border-box',
  blockSize: '100%',

  [`${Legend}`]: {
    display: 'none',
  },

  '& .ant-collapse-header': {
    borderBlockEnd: `1rem solid ${theme.filter.primary.border}`,
    borderRadius: '0 !important',
  },

  '& .ant-collapse-header-text': {
    fontSize: '16rem',
  },

  '&[data-use-button="true"]': {
    marginLeft: '20rem',
  },

  '&[data-use-button="true"] .ant-collapse-expand-icon': {
    position: 'absolute',
    left: '230rem',
  },
}));

export const ExpandedFilterHeader = styled.header(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',

  paddingBlockEnd: '10rem',
  borderBlockEnd: `1rem solid ${theme.filter.secondary.border}`,
  marginBlockEnd: '8rem',
  fontFamily: theme.typography.family.arial,
}));

export const CollapsedFilterHeader = styled.div({
  display: 'flex',
  flexWrap: 'wrap',
  flexDirection: 'row',
  alignItems: 'center',
  columnGap: '20rem',
  rowGap: '10rem',

  '&[data-use-button="true"]': {
    marginLeft: '20rem',
  },
});

export const OpenFiltersBtn = styled(CommonButton)({
  inlineSize: 'clamp(150rem, 100%, 178rem)',
  position: 'relative',
  fontFamily: 'Arial',

  '& .anticon.anticon-down': {
    position: 'absolute',
    right: '10rem',
  },
});

export const FilterTitle = styled.label(({ theme }) => ({
  width: '250rem',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  paddingLeft: '15rem',
  color: theme.palette.erieBlack,

  cursor: 'pointer',

  '& .ant-btn': {
    borderColor: 'transparent',
  },

  '& .ant-btn:hover': {
    color: `${theme.palette.black} !important`,
    borderColor: 'transparent !important',
  },

  '& .anticon.anticon-up': {
    fontSize: '14rem',
  },
}));

export const Collapse = styled(AntdCollapse)(({ theme }) => ({
  '& .ant-collapse-header-text': {
    color: theme.palette.erieBlack,
  },
}));
